/**
 * Javascript App Entry File
 * @file: Javascript App entry file.
 *
 * @version 1.0.0
 *
 * @since 1.0.0
 *
 *	jQuery is a dependency of Bootstrap v4.
 */

//Using jQuery v3.5.1
import jquery from "./vendors/jquery/jquery.min.js";

//Using Bootstrap v4.5.3
import bootstrap from "./vendors/bootstrap/bootstrap.bundle.min.js";

//Pipsqueak Test Working
//import hello from "./modules/hello-world";

//Attach Module to window object
//window.pips = {hello};